import {
  Component, ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {getTravelerTitle, PaxBreakdownInfo} from "../../interfaces/passenger";
import {NgbPopover} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-show-pax-breakdown-info',
  templateUrl: './show-pax-breakdown-info.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./show-pax-breakdown-info.component.scss']
})
export class ShowPaxBreakdownInfoComponent implements OnChanges, OnInit {

  @Input() consumerPrice;
  @Input() passengers = [];
  @Input() passengerType: string;
  @Input() services = [];
  @Input() seats = [];
  @Input() isPDF: boolean;
  @Input() showOnlyFare = false;
  @ViewChild('popover') popover: NgbPopover;

  travelers: {[key: string]: number} = {};
  paxes: PaxBreakdownInfo[];
  serviceTotals: any[];
  getTravelerTitle = getTravelerTitle;

  servicesTotalPrice = 0;
  seatsTotalPrice = 0;

  buttonName = 'info_outline';

  @HostListener('click') onClick() {
    if (this.popover && !this.popover.isOpen()) {
      this.popover.open();
    }
  }

  @HostListener('mouseover') onMouseEnter() {
    this.buttonName = 'info';
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.popover && !this.popover.isOpen()) {
      this.buttonName = 'info_outline';
    }
  }

  @HostListener('document:click', ['$event']) onClickOut(event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.buttonName = 'info_outline';
    }
  }

  constructor(private elementRef: ElementRef) { }

  ngOnChanges(changes: SimpleChanges) {
    this.prepareTravelers();
    this.preparePricingData();
  }

  ngOnInit() {
    this.seatsTotalPrice = this.getTotalPrice(this.seats);
    this.servicesTotalPrice = this.getTotalPrice(this.services);
  }

  getTotalPrice(arr: any[]): number {
    let totalPrice = 0;
    if (arr?.length) {
      arr.map((el) => {
        totalPrice += el.price.consumer.total;
      });
    }
    return totalPrice;
  }

  preparePricingData() {
    this.paxes = [];
    this.serviceTotals = [];

    let paxHolder: any = {};
    let serviceHolder: any = {};

    this.consumerPrice?.breakdown?.forEach((item) => {
      if (item.type) {
        const key = item.type;
        serviceHolder[key] = {
          type: item.type,
          base: (serviceHolder[key]?.base ?? 0) + (item.base ?? 0),
          total: (serviceHolder[key]?.total ?? 0) + (item.tax?.total ?? 0)
        };
      } else {
        paxHolder[item.passengerType + item.base + item.tax?.total] = {
          base: item.base,
          surcharge: item.surcharge,
          total: item.tax?.total,
          passengerType: item.passengerType,
          passengerRefs: item.passengerRefs
        };
      }
    });

    for (let prop in paxHolder) {
      this.paxes.push(
        { base: paxHolder[prop].base,
          surcharge: paxHolder[prop].surcharge,
          total: paxHolder[prop].total,
          passengerType: paxHolder[prop].passengerType,
          passengerRefs: paxHolder[prop].passengerRefs
        });
    }

    for (let prop in serviceHolder) {
      this.serviceTotals.push({
        type: serviceHolder[prop].type,
        base: serviceHolder[prop].base,
        total: serviceHolder[prop].total
      });
    }
  }

  prepareTravelers() {
    if (this.passengers?.length) {
      [...this.passengers].forEach(passenger => {
        const type = passenger.passengerType.toLowerCase();
        this.travelers[type] ? this.travelers[type] += 1 : this.travelers[type] = 1;
      });
    }
  }

  getTotal(pax: PaxBreakdownInfo) {
    const total = ((pax.base ?? 0) + (pax.total ?? 0) + (pax.surcharge ?? 0)) * 100;
    return parseInt(total.toString()) / 100;
  }

  getPaxNumber(pax: PaxBreakdownInfo) {
    return this.travelers[pax.passengerType?.toLowerCase()] ||
      (pax.passengerRefs ? pax.passengerRefs.split(' ').length : 1);
  }

}
